import { render, staticRenderFns } from "./ElPriceInput.vue?vue&type=template&id=d0453e88&scoped=true"
import script from "./ElPriceInput.vue?vue&type=script&lang=js"
export * from "./ElPriceInput.vue?vue&type=script&lang=js"
import style0 from "./ElPriceInput.vue?vue&type=style&index=0&id=d0453e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0453e88",
  null
  
)

export default component.exports